import { AppShell } from '@/components/layout/AppShell';
import { DataStatePanel } from '@/components/shared/DataStatePanel';
import { EmptyState } from '@/components/shared/EmptyState';
import { PageHeader } from '@/components/shared/PageHeader';
import { SignupTimeline } from '@/components/signups/SignupTimeline';
import { useGuildData } from '@/hooks/useGuildData';

export function MySignupsPage(): JSX.Element {
  const { getMySignups, isLoading, error, refreshData } = useGuildData();
  const groups = getMySignups();

  return (
    <AppShell>
      <PageHeader
        title="My Signups"
        description="Your current and past signups."
      />

      {isLoading ? (
        <DataStatePanel title="Loading your signup history" description="Fetching your current and archived mass participation." />
      ) : error ? (
        <DataStatePanel title="Unable to load signups" description={error} actionLabel="Retry" onAction={() => void refreshData()} />
      ) : groups.length > 0 ? (
        <SignupTimeline groups={groups} />
      ) : (
        <EmptyState title="No signup history yet" description="Once you register for a mass, it will appear here." />
      )}
    </AppShell>
  );
}
